import React, { Component } from 'react';
import Link from '../../common/TrackedLink';

class NavBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			text: ''
		};
	}

	handleChange(event) {
		const text = event.target.value;
		this.setState({ text });
		this.props.onChange(text);
	}

	render() {
		return (
			<nav className="video-categories-nav">
				<div className="row">
					<div className="col sm-6">
						<ul>
							<li>
								<Link
									to="/support/videos"
									activeClassName="active"
									trackEvent="Support Video"
									trackEventCategory="Support"
									trackEventAction="Video Filter"
								>
									All
								</Link>
							</li>
							{/* <li>
								<Link
									to="/support/videos/getting-started"
									activeClassName="active"
									trackEvent="Support Video"
									trackEventCategory="Support"
									trackEventAction="Video Filter"
								>
									Getting Started
								</Link>
							</li> */}
							<li>
								<Link
									to="/support/videos/products"
									activeClassName="active"
									trackEvent="Support Video"
									trackEventCategory="Support"
									trackEventAction="Video Filter"
								>
									Products
								</Link>
							</li>
							<li>
								<Link
									to="/support/videos/support"
									activeClassName="active"
									trackEvent="Support Video"
									trackEventCategory="Support"
									trackEventAction="Video Filter"
								>
									Support
								</Link>
							</li>
						</ul>
					</div>
					<div className="col sm-6">
						<div className="video-search">
							<label htmlFor="videoSearch" className="assistive-text">Search</label>
							<input
								type="text"
								id="videoSearch"
								value={this.state.text}
								placeholder="Search"
								className="form-control"
								onChange={event => this.handleChange(event)}
							/>
						</div>
					</div>
				</div>
			</nav>
		);
	}
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/pages/support/videos/NavBar.js